"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleRecommendationResponse = exports.RuleRecommendation = exports.VendorEventSummaryResponse = exports.VendorEventCountByIssue = exports.ScoreTimelineQuerystring = exports.RecommendRulesBody = exports.ListAllVendorEventsQuerystring = exports.ListVendorEventsQuerystring = exports.VendorEventIdParams = exports.VendorProfileIdParams = exports.UpdateVendorEventInput = exports.PatchVendorEventInput = exports.CreateVendorEventInput = exports.VendorEventTransport = exports.ComplianceCategoryWithIssuesTransport = exports.ComplianceIssueTransport = exports.ComplianceCategoryTransport = exports.CategoryContentSchema = exports.EvidenceItemSchema = exports.EscalationStage = exports.EscalationStages = exports.FatalAction = exports.FatalActions = exports.VendorEventSource = exports.VendorEventSources = exports.VendorEventType = exports.VendorEventTypes = exports.VendorEventDefaultHiddenStatuses = exports.VendorEventTerminalStatuses = exports.VendorEventStatus = exports.VendorEventStatuses = exports.ComplianceIssueScope = exports.ComplianceIssueScopes = exports.ComplianceIssueSeverity = exports.ComplianceIssueSeverities = exports.ComplianceCategoryStatus = exports.ComplianceCategoryStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const score_transport_1 = require("./score-transport");
// ── Enum-like const arrays + Typebox unions ────────────────────────────
exports.ComplianceCategoryStatuses = ['ACTIVE', 'INACTIVE'];
exports.ComplianceCategoryStatus = typebox_1.Type.Union(exports.ComplianceCategoryStatuses.map((v) => typebox_1.Type.Literal(v)));
exports.ComplianceIssueSeverities = ['WARNING', 'ESCALATION', 'FATAL'];
exports.ComplianceIssueSeverity = typebox_1.Type.Union(exports.ComplianceIssueSeverities.map((v) => typebox_1.Type.Literal(v)));
exports.ComplianceIssueScopes = ['SERVICE_LINE', 'NETWORK_WIDE'];
exports.ComplianceIssueScope = typebox_1.Type.Union(exports.ComplianceIssueScopes.map((v) => typebox_1.Type.Literal(v)));
exports.VendorEventStatuses = [
    'CREATED',
    'ACKNOWLEDGED',
    'VALIDATED',
    'RESOLVED',
    'CLOSED',
    'ENFORCEMENT_ASSIGNED',
];
exports.VendorEventStatus = typebox_1.Type.Union(exports.VendorEventStatuses.map((v) => typebox_1.Type.Literal(v)));
/**
 * Statuses that represent a closed-out event — no further action expected.
 * Used to compute "active" counts/lists (e.g. `getSummary`'s `totalActive`, the
 * category drawer's Active/Past split). Do not use this for the Compliance
 * dashboard's default-hidden filter — see `VendorEventDefaultHiddenStatuses`.
 */
exports.VendorEventTerminalStatuses = ['RESOLVED', 'CLOSED', 'ENFORCEMENT_ASSIGNED'];
/**
 * Statuses hidden from the Compliance dashboard's default (no `status` filter)
 * view (ENG-1381). Deliberately narrower than `VendorEventTerminalStatuses`:
 * `ENFORCEMENT_ASSIGNED` events still represent actionable enforcement work, so
 * they stay visible by default even though they are "terminal" for scoring
 * purposes. Only `RESOLVED` and `CLOSED` are hidden.
 */
exports.VendorEventDefaultHiddenStatuses = ['RESOLVED', 'CLOSED'];
exports.VendorEventTypes = ['COMPLIANCE_VIOLATION', 'PERFORMANCE_EVENT'];
exports.VendorEventType = typebox_1.Type.Union(exports.VendorEventTypes.map((v) => typebox_1.Type.Literal(v)));
exports.VendorEventSources = ['ADMIN_PORTAL', 'SYSTEM'];
exports.VendorEventSource = typebox_1.Type.Union(exports.VendorEventSources.map((v) => typebox_1.Type.Literal(v)));
exports.FatalActions = ['SUSPENSION', 'PERMANENT_BAN'];
exports.FatalAction = typebox_1.Type.Union(exports.FatalActions.map((v) => typebox_1.Type.Literal(v)));
exports.EscalationStages = ['OK', 'WARNING', 'ESCALATION', 'FATAL'];
exports.EscalationStage = typebox_1.Type.Union(exports.EscalationStages.map((v) => typebox_1.Type.Literal(v)));
// ── Evidence item (shared between VendorEvent schemas) ───────────────
exports.EvidenceItemSchema = typebox_1.Type.Object({
    type: typebox_1.Type.Union([typebox_1.Type.Literal('note'), typebox_1.Type.Literal('url'), typebox_1.Type.Literal('file'), typebox_1.Type.Literal('document')]),
    value: typebox_1.Type.String(),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
});
// ── Category content schema (markdown-supported) ──────────────────────
exports.CategoryContentSchema = typebox_1.Type.Object({
    ruleDetails: typebox_1.Type.Optional(typebox_1.Type.String()),
    faqs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Object({
        question: typebox_1.Type.String(),
        answer: typebox_1.Type.String(),
    }))),
    enforcementDetails: typebox_1.Type.Optional(typebox_1.Type.Record(typebox_1.Type.String(), typebox_1.Type.Array(typebox_1.Type.String()))),
});
// ── Transport schemas ──────────────────────────────────────────────────
/** Compliance category -- top-level grouping for compliance issues */
exports.ComplianceCategoryTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    label: typebox_1.Type.String(),
    key: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    status: exports.ComplianceCategoryStatus,
    sortOrder: typebox_1.Type.Integer(),
    internalContent: typebox_1.Type.Optional(typebox_1.Type.Union([exports.CategoryContentSchema, typebox_1.Type.Null()])),
    externalContent: typebox_1.Type.Optional(typebox_1.Type.Union([exports.CategoryContentSchema, typebox_1.Type.Null()])),
    metadata: common_1.MetaData,
});
/** Individual compliance issue within a category */
exports.ComplianceIssueTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    categoryId: typebox_1.Type.String({ format: 'uuid' }),
    categoryKey: typebox_1.Type.String(),
    label: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    status: exports.ComplianceCategoryStatus,
    severity: typebox_1.Type.Union([exports.ComplianceIssueSeverity, typebox_1.Type.Null()]),
    scope: exports.ComplianceIssueScope,
    rollingWindowDays: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    warningThreshold: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    escalationThreshold: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    fatalThreshold: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    fatalAction: typebox_1.Type.Optional(exports.FatalAction),
    enforcementConfig: typebox_1.Type.Optional(typebox_1.Type.Union([
        typebox_1.Type.Record(typebox_1.Type.String(), typebox_1.Type.Object({ actions: typebox_1.Type.Array(typebox_1.Type.String()), description: typebox_1.Type.Optional(typebox_1.Type.String()) })),
        typebox_1.Type.Null(),
    ])),
    sortOrder: typebox_1.Type.Integer(),
    metadata: common_1.MetaData,
});
/** Category with its nested issues */
exports.ComplianceCategoryWithIssuesTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    label: typebox_1.Type.String(),
    key: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    status: exports.ComplianceCategoryStatus,
    sortOrder: typebox_1.Type.Integer(),
    internalContent: typebox_1.Type.Optional(typebox_1.Type.Union([exports.CategoryContentSchema, typebox_1.Type.Null()])),
    externalContent: typebox_1.Type.Optional(typebox_1.Type.Union([exports.CategoryContentSchema, typebox_1.Type.Null()])),
    metadata: common_1.MetaData,
    issues: typebox_1.Type.Array(exports.ComplianceIssueTransport),
});
/** A single vendor event record against a hauler */
exports.VendorEventTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    vendorId: typebox_1.Type.String({ format: 'uuid' }),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    eventType: exports.VendorEventType,
    source: exports.VendorEventSource,
    // Score rating this event counts against (denormalized `score_rating_config.code`).
    // Set for PERFORMANCE_EVENT, null for COMPLIANCE_VIOLATION.
    ratingCode: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    complianceIssueId: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'uuid' }), typebox_1.Type.Null()])),
    issueLabel: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    categoryKey: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    categoryLabel: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    severity: typebox_1.Type.Optional(typebox_1.Type.Union([exports.ComplianceIssueSeverity, typebox_1.Type.Null()])),
    resolvedSeverity: typebox_1.Type.Optional(typebox_1.Type.Union([exports.ComplianceIssueSeverity, typebox_1.Type.Null()])),
    scope: typebox_1.Type.Optional(typebox_1.Type.Union([exports.ComplianceIssueScope, typebox_1.Type.Null()])),
    // Polymorphic reference to the entity this event is about. Every event has one:
    // 'sourgum-order' / 'operations-subscription' / 'sourgum-vendor' (vendor-level).
    entityType: common_1.EntityType,
    entityId: typebox_1.Type.String(),
    // Soft reference to the internal ticket auto-created alongside this violation, if any.
    internalTicketId: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'uuid' }), typebox_1.Type.Null()])),
    status: exports.VendorEventStatus,
    description: typebox_1.Type.String(),
    evidence: typebox_1.Type.Optional(typebox_1.Type.Array(exports.EvidenceItemSchema)),
    assignedReviewerId: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    resolvedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    occurredAt: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'date-time' }), typebox_1.Type.Null()])),
    disputable: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Boolean(), typebox_1.Type.Null()])),
    reasoning: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    allowDispute: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Boolean(), typebox_1.Type.Null()])),
    fatalAction: typebox_1.Type.Optional(typebox_1.Type.Union([exports.FatalAction, typebox_1.Type.Null()])),
    acknowledgedBy: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'uuid' }), typebox_1.Type.Null()])),
    acknowledgedAt: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'date-time' }), typebox_1.Type.Null()])),
    validatedBy: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'uuid' }), typebox_1.Type.Null()])),
    validatedAt: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'date-time' }), typebox_1.Type.Null()])),
    resolvedBy: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'uuid' }), typebox_1.Type.Null()])),
    metadata: common_1.MetaData,
});
/** Request body for creating a vendor event */
exports.CreateVendorEventInput = typebox_1.Type.Object({
    complianceIssueId: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    eventType: typebox_1.Type.Optional(exports.VendorEventType),
    source: typebox_1.Type.Optional(exports.VendorEventSource),
    // Required for PERFORMANCE_EVENT — the score rating this event counts against
    // (denormalized `score_rating_config.code`, e.g. 'ROLL_OFF_ON_TIME_SERVICE').
    ratingCode: typebox_1.Type.Optional(typebox_1.Type.String()),
    // The entity this event is about. For an order-scoped violation pass
    // 'sourgum-order' + the order UUID; otherwise 'sourgum-vendor' + the vendor UUID
    // (or 'operations-subscription' + the subscription UUID).
    entityType: common_1.EntityType,
    entityId: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    evidence: typebox_1.Type.Optional(typebox_1.Type.Array(exports.EvidenceItemSchema)),
    disputable: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    occurredAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    // When true, also create a linked internal ticket ("Violation Reported: <description>")
    // against the same entity, and store its id on the vendor event.
    createInternalTicket: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
/** Request body for PATCH update — nullable unions for fields that can be cleared */
exports.PatchVendorEventInput = typebox_1.Type.Object({
    status: typebox_1.Type.Optional(exports.VendorEventStatus),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    assignedReviewerId: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'uuid' }), typebox_1.Type.Null()])),
    resolvedAt: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'date-time' }), typebox_1.Type.Null()])),
    disputable: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    evidence: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Array(exports.EvidenceItemSchema), typebox_1.Type.Null()])),
    reasoning: typebox_1.Type.Optional(typebox_1.Type.String()),
    allowDispute: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
/** @deprecated Use PatchVendorEventInput instead */
exports.UpdateVendorEventInput = exports.PatchVendorEventInput;
// ── API contract schemas (params, querystrings) ─────────────────────
exports.VendorProfileIdParams = typebox_1.Type.Object({ profileId: typebox_1.Type.String({ format: 'uuid' }) });
exports.VendorEventIdParams = typebox_1.Type.Object({ id: typebox_1.Type.String({ format: 'uuid' }) });
exports.ListVendorEventsQuerystring = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Number({ minimum: 1, maximum: 200 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Number({ minimum: 0 })),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    complianceIssueId: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    eventType: typebox_1.Type.Optional(exports.VendorEventType),
});
exports.ListAllVendorEventsQuerystring = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Number({ minimum: 1, maximum: 200 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Number({ minimum: 0 })),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorId: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    severity: typebox_1.Type.Optional(typebox_1.Type.String()),
    categoryKey: typebox_1.Type.Optional(typebox_1.Type.String()),
    eventType: typebox_1.Type.Optional(exports.VendorEventType),
    // When `status` is omitted, the default view hides RESOLVED/CLOSED events
    // (ENG-1381). Pass `includeResolved: true` to opt back into seeing them
    // without pinning to an explicit status list.
    includeResolved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.RecommendRulesBody = typebox_1.Type.Object({
    description: typebox_1.Type.String({ minLength: 5 }),
    // Optional service line: when set, only that line's performance ratings are recommendable.
    // Compliance issues are recommended regardless (they apply to both lines).
    serviceType: typebox_1.Type.Optional(score_transport_1.ScoreServiceType),
});
/**
 * Querystring for the score timeline — the vendor's score-affecting events (those linked to a
 * score rating via `ratingCode`), most-recent first. Optionally narrowed to a single rating.
 */
exports.ScoreTimelineQuerystring = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Number({ minimum: 1, maximum: 200 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Number({ minimum: 0 })),
    ratingCode: typebox_1.Type.Optional(typebox_1.Type.String()),
});
/** Per-issue vendor event count with escalation stage */
exports.VendorEventCountByIssue = typebox_1.Type.Object({
    complianceIssueId: typebox_1.Type.String({ format: 'uuid' }),
    issueLabel: typebox_1.Type.String(),
    categoryKey: typebox_1.Type.String(),
    categoryLabel: typebox_1.Type.String(),
    severity: typebox_1.Type.Union([exports.ComplianceIssueSeverity, typebox_1.Type.Null()]),
    scope: exports.ComplianceIssueScope,
    count: typebox_1.Type.Integer(),
    rollingWindowDays: typebox_1.Type.Union([typebox_1.Type.Integer(), typebox_1.Type.Null()]),
    currentStage: exports.EscalationStage,
});
/** Summary response for a hauler's vendor event overview */
exports.VendorEventSummaryResponse = typebox_1.Type.Object({
    totalActive: typebox_1.Type.Integer(),
    countsByIssue: typebox_1.Type.Array(exports.VendorEventCountByIssue),
    recentEvents: typebox_1.Type.Array(exports.VendorEventTransport),
});
/**
 * AI-powered rule recommendation result. `kind` disambiguates the two recommendable rule types:
 * a compliance issue (carries `complianceIssueId` + `categoryKey`) or a SourScore performance
 * rating (carries `ratingCode`, e.g. quality / billing accuracy).
 */
exports.RuleRecommendation = typebox_1.Type.Object({
    kind: typebox_1.Type.Union([typebox_1.Type.Literal('compliance'), typebox_1.Type.Literal('performance')]),
    complianceIssueId: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    ratingCode: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    issueLabel: typebox_1.Type.String(),
    categoryKey: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    confidence: typebox_1.Type.Number(),
    reason: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.RuleRecommendationResponse = typebox_1.Type.Object({
    recommendations: typebox_1.Type.Array(exports.RuleRecommendation),
});
//# sourceMappingURL=compliance-transport.js.map